import { ResultObj, checkSign, ExportURL, getPermision, esd_storage } from "./Domain";
import XLSX from "xlsx";
import { IndexedDBClass } from "./indexedDB";
import { HandleEvent, permissionPageInfo } from "./types";
import { CustomDate } from "../utils/date/dateExtension";
import { debounceFn } from "./hooks";
import { ApiVersionName } from "./Domain";
import { createElement } from "react";
import { Box, CircularProgress } from "@material-ui/core";
import { globalEnqueueSnackbar, globalCloseSnackbar } from "./GlobalSnackbar";

export const DateTimeFormate = (() => {

    /**
     * 格式
     * yyyy | yyyyMM | yyyyMMdd | yyyyMMddhhmm | yyyyMMddhhmmss | MMddhhmm | MMdd | hhmm | hhmmss
     */
    enum DateMode {
        yyyy = "yyyy",
        yyyyMM = "yyyyMM",
        yyyyMMdd = "yyyyMMdd",
        yyyyMMddhhmm = "yyyyMMddhhmm",
        yyyyMMddhhmmss = "yyyyMMddhhmmss",
        MMddhhmm = "MMddhhmm",
        MMdd = "MMdd",
        hhmm = "hhmm",
        hhmmss = "hhmmss",
    }

    // 時間處理
    let TimeFormate = (() => {
        let _minToHour = (mins: number) => (mins / 60).toFixed(1);
        let _formate = (time: string) => time.substring(0, 2) + ":" + time.substring(2, 4);
        let _formateNum = (time: string) => time.substring(0, 2) + time.substring(2, 4);
        // a.replace(/[0-9]{2}\:[0-9]{2}/gm,"");
        /**
         * 是否為合理的時間區間
         * @param {string} start 起始時間
         * @param {string} end 結束時間
         * @param {string} across_night 是否跨夜 
         */
        let _reasonableTime = (start = "", end = "", across_night = "N") => {
            let s = parseInt(start), e = parseInt(end), a = across_night.toUpperCase();
            if (s > e && a === "Y") return true;
            else if (s < e && a === "Y") return true;
            else if (s > e && a === "N") return false;
            else if (s < e && a === "N") return true;
        };
        return { _minToHour, _formate, _formateNum, _reasonableTime };
    })()

    // 拿到今天日期 yyyy-mm-dd
    let todayDateFormate = function ({ Mode = "yyyyMMdd", joinDate = "-", joinTime = ":", joinDateTime = " " }) {
        let toTwoDigit = (num: string) => ("00" + num).slice(-2);
        let d: Date = new Date(), str = "";
        let y = d.getFullYear().toString(),
            M = toTwoDigit((d.getMonth() + 1).toString()),
            date = toTwoDigit(d.getDate().toString()),
            H = toTwoDigit(d.getHours().toString()),
            m = toTwoDigit(d.getMinutes().toString()),
            s = toTwoDigit(d.getSeconds().toString());

        switch (Mode) {
            case "yyyyMMddhhmmss":
                str = y + joinDate + M + joinDate + date + joinDateTime + H + joinTime + m + joinTime + s;
                break;
            case "yyyyMMddhhmm":
                str = y + joinDate + M + joinDate + date + joinDateTime + H + joinTime + m;
                break;
            case "yyyyMMdd":
                str = y + joinDate + M + joinDate + date;
                break;
            case "yyyy":
                str = y;
                break;
            case "yyyyMM":
                str = y + joinDate + M;
                break;
            case "MMdd":
                str = M + joinDate + date;
                break;
            case "hhmm":
                str = H + joinTime + m;
                break;
            case "hhmmss":
                str = H + joinTime + m + joinTime + s;
                break;
            case "number":
                str = y + M + date;
                break;
            default:
                str = y + joinDate + M + joinDate + date + " " + H + joinTime + m;
                break;
        }
        return str;
    }
    // 轉日期 yyyy/mm/dd
    let dateToString = function (obj: {
        date: Date, mode: DateMode, joinDate?: string, joinTime?: string, joinDateTime?: string
    }): string {
        let { date, mode = "yyyyMMdd", joinDate = "/", joinTime = ":", joinDateTime = " " } = { ...obj };
        let str = "";
        // 保證 date 是 有效 Date
        if (date instanceof Date && !isNaN(date.getTime())) {
            let year = date.getFullYear().toString(),
                month = ("00" + (date.getMonth() + 1)).slice(-2),
                day = ("00" + date.getDate()).slice(-2),
                hour = ("00" + date.getHours()).slice(-2),
                min = ("00" + date.getMinutes()).slice(-2),
                sec = ("00" + date.getSeconds()).slice(-2);

            switch (mode) {
                case "yyyy":
                    str = year;
                    break;
                case "yyyyMM":
                    str = year + joinDate + month;
                    break;
                case "yyyyMMdd":
                    str = year + joinDate + month + joinDate + day;
                    break;
                case "yyyyMM":
                    str = year + joinDate + month;
                    break;
                case "yyyyMMddhhmm":
                    str = year + joinDate + month + joinDate + day + joinDateTime + hour + joinTime + min;
                    break;
                case "yyyyMMddhhmmss":
                    str = year + joinDate + month + joinDate + day + joinDateTime + hour + joinTime + min + joinTime + sec;
                    break;
                case "MMdd":
                    str = month + joinDate + day;
                    break;
                case "hhmm":
                    str = hour === "" && min === "" ?
                        "" :
                        hour + joinTime + min;
                    break;
                case "hhmmss":
                    str = hour === "" && min === "" && sec === "" ?
                        "" :
                        hour + joinTime + min + joinTime + sec;
                    break;
                default:
                    str = year + joinDate + month + joinDate + day;
                    break;
            }
        } else {
            console.error('Invalid Date')
        }
        return str;
    }

    /** 因應真正日期(不同年份的是否有229) 確認日期是否存在
     * @param {string} dateStr 日期字串 YYYY/MM/DD
     * @ return {boolean} 布林值 :是否存在
     * @ EX: isExistDate('2023/02/29'); false
     * @ EX: isExistDate('2024/02/29'); true
     */
    let isExistDate = function (dateStr: string) {
        const
            /** 使用 Date 物件建立日期*/
            actuallyDate = new Date(dateStr),
            // 字串的年月份
            year = parseInt(dateStr.split('/')[0]),
            month = parseInt(dateStr.split('/')[1]),
            day = parseInt(dateStr.split('/')[2])
        // 檢查日期是否正確
        return actuallyDate.getFullYear() === year && actuallyDate.getMonth() === month - 1 && actuallyDate.getDate() === day;
    }

    /**
     * @description 本月第一天
     * @param {*}
     * @returns 
     */
    let getMonthStart = function (date: Date | null = null) {
        let d = date === null ? new Date() : date;
        let start = new Date(d.getFullYear(), d.getMonth(), 1);
        return new Date(start);
    }

    /**
     * @description 本月最後一天
     * @param {*}
     * @returns 
     */
    let getMonthEnd = function (date: Date | null = null) {
        let d = date === null ? new Date() : date;
        let end = new Date(d.getFullYear(), d.getMonth() + 1, 0);
        return new Date(end);
    }

    /** 推算六個月前，該月份第一天 */
    let getSixMonthsAgoStartDate = function (date: Date | null = null) {
        let d = date === null ? new Date() : date;
        // 往前推六個月
        d.setMonth(d.getMonth() - 5);
        // 推算後該月份的第一天
        let start = new Date(d.getFullYear(), d.getMonth(), 1);
        return start;
    }


    /**
     *
     * @description 20181110162804 -> 2018-11-10 16:28:04
     * @param {string} dateStr 日期字串, ex: 20181110162804
     * @param {string} Mode 顯示模式, ex: yyyyMMddhhmmss
     * @param {string} Length 日期長度 < 4 | 6 | 8 | 12 | 14 >
     * @param {string} joinDate 日期之間穿插的符號
     * @param {string} joinTime 時間之間穿插的符號
     * @param {string} joinDateTime 日期跟時間之間穿插的符號
     * @description 空值(null / undefined / "")、非日期字串、以及後端未填值時回傳的預設日期
     *              (ex. 0001-01-01T00:00:00、1900-01-01) 一律回傳 ""，呼叫端不需要再自行判斷
     */
    let dateFormate = function (obj: {
        dateStr: string | null | undefined, Mode?: DateMode, Length?: string, joinDate?: string, joinTime?: string, joinDateTime?: string,
    }): string {
        let { dateStr = "", Mode = null, Length = null, joinDate = "-", joinTime = ":", joinDateTime = " " } = { ...obj };
        let mode = null, num = null;
        // null / undefined 不能用 == "" 判斷 (null == "" 為 false)，會被 dateRegex 轉成 "null" 字串
        if (dateStr === null || dateStr === undefined || dateStr === "") return "";
        //預先將 dateStr 去除符號
        dateStr = dateRegex(dateStr)
        if (dateStr === "") return "";
        // 非日期字串 (ex. "null"、"undefined"、"Invalid Date")
        if (!/^\d{4}/.test(dateStr)) return "";
        // 長度 >= 8 才含有完整日期，此時才判斷是否為後端的預設日期；
        // 長度 < 8 有可能是 hhmm / hhmmss / MMdd 這類純時間字串，不可當年份判斷
        if (dateStr.length >= 8 && Number(dateStr.substring(0, 4)) <= 1900) return "";

        if (Mode == null && Length == null) num = dateStr.length;
        else if (Mode != null) mode = Mode;
        else if (Length != null) num = Length;
        if (num != null) {
            if (num === 14) return `${dateStr.substr(0, 4)}${joinDate}${dateStr.substr(4, 2)}${joinDate}${dateStr.substr(6, 2)} ${dateStr.substr(8, 2)}${joinTime}${dateStr.substr(10, 2)}${joinTime}${dateStr.substr(12, 2)}`;
            else if (num === 12) return `${dateStr.substr(0, 4)}${joinDate}${dateStr.substr(4, 2)}${joinDate}${dateStr.substr(6, 2)} ${dateStr.substr(8, 2)}${joinTime}${dateStr.substr(10, 2)}`;
            else if (num === 8) return `${dateStr.substr(0, 4)}${joinDate}${dateStr.substr(4, 2)}${joinDate}${dateStr.substr(6, 2)}`;
            else if (num === 6) return `${dateStr.substr(0, 4)}${joinDate}${dateStr.substr(4, 2)}`;
            else if (num === 4) return `${dateStr.substr(0, 2)}${joinTime}${dateStr.substr(2, 2)}`;
            else return `${dateStr.substr(0, 4)}${joinDate}${dateStr.substr(4, 2)}${joinDate}${dateStr.substr(6, 2)} ${dateStr.substr(8, 2)}${joinTime}${dateStr.substr(10, 2)}${joinTime}${dateStr.substr(12, 2)}`;
        } else if (mode != null) {
            dateStr = dateStr.replace(/\-\:\./gm, "");
            let str = "";
            let year = dateStr.substring(0, 4);
            let month = dateStr.substring(4, 6);
            let day = dateStr.substring(6, 8);
            let hr = dateStr.substring(8, 10);
            let m = dateStr.substring(10, 12);
            let sec = dateStr.substring(12, 14);

            switch (String(Mode)) {
                case DateMode.yyyyMMddhhmmss:
                    str = `${year}${joinDate}${month}${joinDate}${day}${joinDateTime}${hr}${joinTime}${m}${joinTime}${sec}`;
                    break;
                case DateMode.yyyyMMddhhmm:
                    str = `${year}${joinDate}${month}${joinDate}${day}${joinDateTime}${hr}${joinTime}${m}`;
                    break;
                case DateMode.yyyyMMdd:
                    str = `${year}${joinDate}${month}${joinDate}${day}`;
                    break;
                case DateMode.yyyyMM:
                    str = `${year}${joinDate}${month}`;
                    break;
                case DateMode.yyyy:
                    str = year;
                    break;
                case DateMode.MMddhhmm:
                    str = `${month}${joinDate}${day}${joinDateTime}${hr}:${m}`;
                    break;
                case DateMode.MMdd:
                    str = `${month}${joinDate}${day}`;
                    break;
                case DateMode.hhmmss:
                    str = `${hr}${joinTime}${m}${joinTime}${sec}`;
                    break;
                case DateMode.hhmm:
                    str = `${hr}${joinTime}${m}`;
                    break;
            }
            if (str === joinTime || str === joinDate) return "";
            else return str;
        } else {
            return "";
        }
    }

    /**
     * 日期格式轉換
     * @param {string} Time 時間參數 (Ex:20190505...)
     * @param {string} Mode 模式 yyyyMMddhhmmss
     */
    let DateFormatSendBack = function (Time = "", Mode: string = "") {
        let EditTime = '';
        let year = Time.substring(0, 4);
        let month = Time.substring(4, 6);
        let day = Time.substring(6, 8);
        let hr = Time.substring(8, 10);
        let m = Time.substring(10, 12);
        let sec = Time.substring(12, 14);
        switch (String(Mode)) {
            case "yyyyMMddhhmmss":
                EditTime = `${year}/${month}/${day} ${hr}:${m}:${sec}`;
                break;
            case "yyyyMMddhhmm":
                EditTime = `${year}/${month}/${day} ${hr}:${m}`;
                break;
            case "yyyyMMdd":
                EditTime = `${year}/${month}/${day}`;
                break;
            case "yyyyMM":
                EditTime = `${year}/${month}`;
                break;
            case "MMddhhmm":
                EditTime = `${month}/${day} ${hr}:${m}`;
                break;
            case "MMdd":
                EditTime = `${month}/${day}`;
                break;
            case "hhmmss":
                EditTime = `${hr}:${m}:${sec}`;
                break;
            case "hhmm":
                EditTime = `${hr}:${m}`;
                break;
        }
        return EditTime;
    }

    /**
     * @description 2018-11-10 -> y=2018,m=11,d=10,date=2018-11-10
     * @param {*} dateText 
     * @returns { y: 年, m: 月, d: 日, h: 時, mm: 分, s: 秒, date: ""}
     */
    let dateFormatObj = function (dateText: string): { y: string, m: string, d: string, h: string | null, mm: string | null, s: string | null, date: string } {
        return {
            y: dateText.substring(0, 4),
            m: dateText.substring(4, 6),
            d: dateText.substring(6, 8),
            h: dateText.length >= 10 ? dateText.substring(8, 10) : null,
            mm: dateText.length >= 10 ? dateText.substring(10, 12) : null,
            s: dateText.length >= 10 ? dateText.substring(12, 14) : null,
            date: dateText
        };
    }

    /**
       * 日期去掉 - / \ : .
       * @param {string} date 日期 ex.2019.10.11
       * @param {string} replaceTo 要取代成什麼樣子，預設取代成 ""
       */
    let dateRegex = function (date: string, replaceTo = "") {
        let dateReg = /[\s\-\/\\\:\T]/gm;
        return String(date).replace(dateReg, replaceTo);
    }

    let dateTimeRegex = function (date: string, replaceTo = "") {
        let dateTimeReg = /[\-a-zA-Z\s\:]/gm;
        return String(date).replace(dateTimeReg, replaceTo);
    }

    /**
     * 取得今天的前後N天的日期
     * @param {number} Count: 天數、月數、年數 (Ex:昨天給 -1;明天給 1)
     * @param {string} dateStr: 日期 (Ex:20220928、202209、2022)
     * dateStr給空就會抓今天的日期，給空才要給 Mode < yyyyMMdd | yyyyMM | yyyy > 
     * dateStr給空，Count就會是天數
     */
    let getNextOrLastDate = function (obj: { Count: number, dateStr: string, Mode: string }) {
        let { Count = 0, dateStr = "", Mode = "" } = obj;
        let num = dateStr.length
        let year = dateStr.substring(0, 4);
        let month = dateStr.substring(4, 6);
        let day = dateStr.substring(6, 8);
        let dd: Date = new Date();
        let ddStr = "";
        if (num === 4) {
            dd = new Date(year)
        } else if (num === 6) {
            let yearInt = parseInt(year);
            let monthInt = parseInt(month);
            if ((monthInt + Count) > 12) { //明年
                dd = new Date(yearInt + 1, (((monthInt + Count) - 12) - 1))
                dd.setDate(dd.getMonth())
            } else if ((monthInt + Count) < 0) { //前年
                dd = new Date(yearInt - 1, (((12 + Count) + monthInt) - 1))
                dd.setDate(dd.getMonth())
            } else { //今年
                dd = new Date(yearInt, (monthInt - 1))
                dd.setMonth(dd.getMonth() + Count)
            }
        } else if (num === 8) {
            let yearInt = parseInt(year);
            let monthInt = parseInt(month);
            dd = new Date(yearInt, (monthInt - 1), parseInt(day))
            dd.setDate(dd.getDate() + Count)
        } else {
            dd.setDate(dd.getDate() + Count)
        }

        let y = num === 4 ? dd.getFullYear() + Count : dd.getFullYear();
        let m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1)
        let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate()

        if (num === 4) {
            ddStr = y.toString()
        } else if (num === 6) {
            ddStr = y.toString() + m.toString()
        } else if (num === 8) {
            ddStr = y.toString() + m.toString() + d.toString()
        } else {
            switch (String(Mode)) {
                case "yyyyMMdd":
                    ddStr = y.toString() + m.toString() + d.toString()
                    break
                case "yyyyMM":
                    ddStr = y.toString() + m.toString()
                    break
                case "yyyy":
                    ddStr = y.toString()
                    break
            }
        }
        return ddStr
    }

    let getDayName = (day: number): string => {
        let d = day.toString();
        let week: { [key: string]: string } = { "0": "日", "1": "一", "2": "二", "3": "三", "4": "四", "5": "五", "6": "六" };
        return week[d];
    }

    let addDays = (date: string, days: number): Date => {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    /**
     * 
     * @param selectedDate 20230529
     * @returns 
     */
    let isDateBeforeToday = function (selectedDate: string): boolean {
        let date = dateFormate({ dateStr: selectedDate })
        // 取得今天的日期（只保留日期，時間設置為午夜）
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        // 將所選日期轉換為Date物件（只保留日期，時間設置為午夜）
        var selected = new Date(date);
        selected.setHours(0, 0, 0, 0);

        // 比較兩個日期的毫秒數
        if (selected < today) {
            return true; // 所選日期早於今天
        } else {
            return false; // 所選日期晚於或等於今天
        }
    }


    /**
     * 取得哪個日期開始不能操作
     * @param {numner} year 年
     * @param {numner} month 月
     * @param {numner} day 日
     * @returns 
     */
    const getDisableDate = (year = 0, month = 0, day = 0) => {
        const currentDate = new Date();


        // 計算完整的年份和月份
        const totalMonths = month;
        const years = Math.floor(Math.abs(totalMonths) / 12);
        const months = Math.abs(totalMonths) % 12;

        // 設置年份
        currentDate.setFullYear(
            totalMonths < 0
                ? currentDate.getFullYear() + year + years
                : currentDate.getFullYear() - year - years
        );

        // 設置月份，考慮天數的變化
        let targetMonth =
            totalMonths < 0
                ? currentDate.getMonth() + months
                : currentDate.getMonth() - months;
        let targetYear = currentDate.getFullYear();

        if (targetMonth < 0) {
            targetMonth += 12;
            targetYear -= 1;
        }
        if (targetMonth > 11) {
            targetMonth -= 12;
            targetYear += 1;
        }

        const targetDate = new Date(targetYear, targetMonth + 1, 0); // 將日期設置為目標月份的最後一天

        if (currentDate.getDate() > targetDate.getDate()) {
            currentDate.setDate(targetDate.getDate());
        }

        // 設置月份和日期
        currentDate.setFullYear(targetDate.getFullYear());
        currentDate.setMonth(targetMonth);
        currentDate.setDate(currentDate.getDate() - day);
        return DateTimeFormate.dateToString({ date: currentDate, mode: DateTimeFormate.DateMode.yyyyMMdd, joinDate: "" });
    };

    /** 增加指定日期 之 任何時間單位 
     * @property {Date} date 指定日期
     * @property {number} years 欲增加之 - 年
     * @property {number} months 欲增加之 - 月
     * @property {number} days 欲增加之 - 日
     * @property {number} hours 欲增加之 - 時
     * @property {number} minutes 欲增加之 - 分
     * @property {number} seconds 欲增加之 - 秒
     * @returns '202407171330'
    */
    function addDateTime({ date, years = 0, months = 0, days = 0, hours = 0, minutes = 0, seconds = 0 }:
        { date: Date, years?: number, months?: number, days?: number, hours?: number, minutes?: number, seconds?: number }) {
        // 添加時間
        date.setFullYear(date.getFullYear() + years);
        date.setMonth(date.getMonth() + months);
        date.setDate(date.getDate() + days);
        date.setHours(date.getHours() + hours);
        date.setMinutes(date.getMinutes() + minutes);
        date.setSeconds(date.getSeconds() + seconds);

        // 格式化輸出
        return date.getFullYear() +
            ('0' + (date.getMonth() + 1)).slice(-2) +
            ('0' + date.getDate()).slice(-2) +
            ('0' + date.getHours()).slice(-2) +
            ('0' + date.getMinutes()).slice(-2) +
            ('0' + date.getSeconds()).slice(-2);
    }

    return {
        DateMode,
        TimeFormate,
        isExistDate,
        todayDateFormate,
        dateToString,
        dateFormate,
        DateFormatSendBack,
        dateFormatObj,
        dateRegex,
        dateTimeRegex,
        getMonthStart,
        getMonthEnd,
        getSixMonthsAgoStartDate,
        getNextOrLastDate,
        getDayName,
        addDays,
        addDateTime,
        isDateBeforeToday,
        getDisableDate,
    }
})();

export const isMobile = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod|android/.test(userAgent);
}

/**
 * 千分位顯示
 * @param {number} number 數字
 * @description 後端某些數值欄位(ex. total_price、insurance_price)實際上可能回傳 null，即使型別寫number，這裡要擋掉避免.toString()噴錯
 */
export const ThousandsDot = (number: number | null | undefined) => {
    if (number === null || number === undefined || isNaN(number)) return "--";

    let num = number.toString();
    let pattern = /(-?\d+)(\d{3})/;

    while (pattern.test(num)) {
        num = num.replace(pattern, "$1,$2");
    }

    if (num === "0") num = "--";

    return num;
}

/**
 * 檔案轉base64
 * @param {*} file 
 * @returns 
 */
export const base64FromFile = (file: File) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

/**
 * URL 轉 base64，會有corss 的問題要注意!
 * @param {*} url 
 * @returns 
 */
export const base64FromURL = (url: string) => new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
        let canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        let ctx = canvas.getContext("2d");
        ctx?.drawImage(img, 0, 0);
        let dataURL = canvas.toDataURL();
        resolve(dataURL);
    };
    img.onerror = error => {
        console.error(url + " 圖片載入失敗，請點擊預覽圖片");
        reject(error);
    };
    img.src = url;
})

/**
 * 用base64 取得寬高比例
 * @param {*} base64 
 * @returns 
 */
export const widthHeightRatio = (base64: string) => new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i.width / i.height);
    i.src = base64;
})


/**
 * @author Daniel Wang 
 * 2023-01-05
 * @description 回應一個indexedDBClass 的物件，不要直接去 new IndexedDBClass，用這個function
 * factory 算是結合輔助工具 配合當前系統功能的地方
 * @returns indexedDBClass
 * indexedDBClass 的class有哪些功能可以參考 IndexedDBClass.js
 * 
 */
export const get_ESD_indexedDB_factory = async () => {
    try {
        let idb = new IndexedDBClass("ESD");
        let r: ResultObj = await idb.openIndexedDB()
            .then(res => res)
            .catch(error => {
                console.log("%cIDB開啟時發生錯誤", "font-size: 1.5rem; background:red;");
                console.error(error.message);
                return error;
            });
        if (r.success) return idb;
        else return r.data;
    } catch (e) {
        console.warn("ESD warning: ", e);
        return null;
    }
}

/**
 * clear object value
 * @param {*} obj 
 * @returns 
 */
export const clearObject = (obj: { [key: string]: any }): { [key: string]: any } => {
    return Object.keys(obj).reduce((accumulator, key) => {
        let defaultValue;
        switch (typeof obj[key]) {
            case "string":
                defaultValue = "";
                break;
            case "number":
                defaultValue = 0;
                break;
            case "boolean":
                defaultValue = false;
                break;
            case "object":
                if (Array.isArray(obj[key])) {
                    defaultValue = [];
                } else if (obj[key] === null) {
                    defaultValue = null;
                } else {
                    defaultValue = clearObject(obj[key]);
                }
                break;
            default:
                defaultValue = null;
        }
        return { ...accumulator, [key]: defaultValue };
    }, {});
};

/**
 * 判斷一個物件裡的key是否都有value
 * @param {*} obj 
 * @returns 
 */
export const checkAllValues = (obj: { [key: string]: any }): boolean => {
    for (let key in obj) {
        if (obj[key] === undefined || obj[key] === "" || obj[key] === null) return false;
    }
    return true;
}

/**
 * @description 拿到經緯度
 * @returns 
 */
export const showUpWorkMakeUpPosition = async () => {
    const location = { latitude: 0, longitude: 0 };
    try {
        const hasGpsPermission = await checkAndRequestGpsPermission();
        if (!hasGpsPermission) {
            return location;
        }

        const position = await getCurrentPosition();
        const { latitude, longitude } = position?.coords || location;
        return { latitude, longitude };
    } catch (error) {
        console.error('Error retrieving geolocation:', error);
        // 出問題的時候經緯度為0
        return location;
    }
};
export const getCurrentPosition = () => {
    return new Promise<Position>((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error('Geolocation is not supported'));
            return;
        }
        navigator.geolocation.getCurrentPosition(resolve, reject);
    });
};

/**
 * 檢查並請求 GPS 權限（跨主流瀏覽器）
 * @returns true: 目前可使用定位；false: 無法使用定位
 */
export const checkAndRequestGpsPermission = async (): Promise<boolean> => {
    const unsupportedMessage = '此瀏覽器或目前環境不支援定位功能，請使用 HTTPS 或 localhost。';
    const deniedMessage = '目前已封鎖定位（GPS）權限。\n請點網址列左側鎖頭圖示 > 網站設定，將「定位」改為「允許」，再重新整理頁面後重試。';
    const failedMessage = '無法取得目前位置，請確認裝置定位服務已開啟後再重試。';

    const showAlert = (message: string) => {
        if (typeof window !== 'undefined' && typeof window.alert === 'function') {
            window.alert(message);
        }
    };

    const requestByGeolocation = async () => {
        try {
            await getCurrentPosition();
            return true;
        } catch (error) {
            const geolocationError = error as GeolocationPositionError;
            if (geolocationError?.code === 1) {
                showAlert(deniedMessage);
            } else {
                showAlert(failedMessage);
            }
            return false;
        }
    };

    if (typeof navigator === 'undefined' || !navigator.geolocation) {
        showAlert(unsupportedMessage);
        return false;
    }

    // 大多數瀏覽器要求在安全環境（HTTPS/localhost）才能使用 geolocation
    if (typeof window !== 'undefined' && !window.isSecureContext) {
        showAlert(unsupportedMessage);
        return false;
    }

    try {
        if (navigator.permissions && typeof navigator.permissions.query === 'function') {
            const permissionStatus = await navigator.permissions.query({ name: 'geolocation' as PermissionName });

            if (permissionStatus.state === 'granted') {
                return true;
            }

            if (permissionStatus.state === 'denied') {
                showAlert(deniedMessage);
                return false;
            }

            // prompt 或其他狀態，改用 geolocation 觸發授權視窗
            return await requestByGeolocation();
        }
    } catch (error) {
        // Safari / iOS 可能不支援 permissions.query(geolocation)，或查詢流程拋錯，直接改用 geolocation 請求
        if (process.env.NODE_ENV === 'development') {
            console.warn('Permissions API query failed, fallback to geolocation request.', error);
        }
        return await requestByGeolocation();
    }

    return await requestByGeolocation();
};
interface Position {
    coords: {
        latitude: number;
        longitude: number;
    };
}

/**
 * 遞迴檢查頁面群組權限
 * @param {String[]} arr 範例: ['Humanresources', 'sidebar', 'SignOff', 'SignOffAuditFirst', 'SignOffAuditSecond']
 * @param {Object} d getPermision 回傳的 data.items
 * @param {Number} seq 沒特殊需求就給 0
 * @returns {boolean}
 */
export let permissionLoop = async (arr: string[], d: permissionPageInfo[], seq: number): Promise<boolean> => {
    let key = arr[seq];
    // 檢查有沒有這個權限
    // 只要進這裡都算是找到
    if (d.some(item => item.name === key || item.code === key)) {
        // 檢查arr 還要跑嗎?
        if (seq < arr.length - 1) {
            let next_data = d.some(item => item.name === key || item.code === key) ?
                d.find(item => item.name === key || item.code === key)!.children :
                [];
            seq++;
            return await permissionLoop(arr, next_data, seq);
        } else return true;

    } else return false;
}

/** 將字串轉為指定的列舉型態
 * 將列舉用泛型的形式丟進來，之後在裡面比對，並確保回傳只會是null或是指定的列舉
 * @author Daniel Wang
 * @returns 
 */
export const toEnum = async <E>(value: string | null, enumObj: { [key: string]: E }): Promise<E | null> => {
    if (value === null) return null;
    else return Object.values(enumObj).includes(value as E) ? value as E : null;
}


// 產生excel
export type gerateBasicBlobExcelProps = {
    fileName: string,
    title: string[],
    contentData: any[][]
}
export const gerateBasicBlobExcel = (fileSetting: gerateBasicBlobExcelProps) => {
    // 創建工作表
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([
        [...fileSetting.title],
        ...fileSetting.contentData
    ]);

    // 給標題行設定背景色
    const range: XLSX.Range = XLSX.utils.decode_range(ws['!ref']!);
    for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell_address: string = `${XLSX.utils.encode_col(C)}1`; // 第一行的單元格地址
        if (!ws[cell_address]) continue;
        if (!ws[cell_address].s) ws[cell_address].s = {};
        ws[cell_address].s.fill = {
            patternType: "solid",
            fgColor: { rgb: "0000FF" }
        };
    }

    // 將所有儲存格都設定為「文字格式」
    Object.keys(ws).forEach((cellAddr) => {
        if (!cellAddr.startsWith("!")) { // 跳過特殊屬性（例如 !ref、!cols）
            const cell = ws[cellAddr];
            // 統一設定為文字格式
            cell.t = "s"; // string
            cell.z = "@"; // Excel 格式為「文字」
            if (typeof cell.v !== "string") {
                cell.v = String(cell.v ?? ""); // 強制轉成文字
            }
        }
    });

    // 創建新工作簿並添加工作表
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // 寫文件
    XLSX.writeFile(wb, `${fileSetting.fileName}.xlsx`);
}

/** 跳轉頁面依照 path 重新設定 session 資料
 * @param targetPath 欲前往的頁面路徑 ex: "/OrderTracking/TrackingSecond"
 * @returns items - 整理好的頁面 Array (設定進 sessionStorage.items)
 * @returns home_page - 該頁的 home page (設定進 sessionStorage.home_page)
 * @returns home_page_name - 該頁的 home page name (設定進 sessionStorage.home_page_name)
 * @description 避免跳轉不同平台或不同群組頁面後麵包屑怪怪
 */

export async function getNewSessionItems(targetPath: string) {
    /** 查詢 所有權限 */
    let resPermision = await checkSign().then(async (loginRes) => {
        if (loginRes.success) {
            return await getPermision(loginRes.data.path);
        } else return null
    })
    /** 整理好的頁面 Array */
    let sessionPageDataArr: permissionPageInfo[] = [],
        /** 該頁的 home page */
        sessionHomePage = '',
        /** 該頁的 home page name */
        sessionHomePageName = ''

    //檢查權限與其首頁
    if (resPermision) {
        // 平台
        for (let platFormIndex in resPermision.items) {
            // sideBar/nav
            /** 平台物件 */
            const platFormItem = resPermision.items[platFormIndex]
            for (let childIndex in resPermision.items[platFormIndex].children) {
                // 平台內 側邊欄陣列
                if (resPermision.items[platFormIndex].children[childIndex].name === "sidebar") {
                    // 檢查
                    for (let sideItemIndex in resPermision.items[platFormIndex].children[childIndex].children) {
                        /** 頁面組別物件 */
                        const sideItem = resPermision.items[platFormIndex].children[childIndex].children[sideItemIndex]
                        // 判斷非控制台
                        if (sideItem.code !== "Index") {
                            for (let firstPageItemIndex in resPermision.items[platFormIndex].children[childIndex].children[sideItemIndex].children) {
                                /** first 頁面物件 */
                                const firstPageItem = resPermision.items[platFormIndex].children[childIndex].children[sideItemIndex].children[firstPageItemIndex]
                                /** second 頁的頁面物件 */
                                let secondPageItem: typeof firstPageItem | undefined = undefined
                                // 查找是否為 Second 頁
                                secondPageItem = firstPageItem.children.find(pcItem => pcItem.path === targetPath)
                                // 若 path 找的到
                                if (firstPageItem.path === targetPath || secondPageItem) {
                                    sessionHomePage = platFormItem.name
                                    sessionHomePageName = platFormItem.children.find(child => child.name === 'nav')?.children.find(navItem => navItem.code === platFormItem.name)?.name || '查詢錯誤'
                                    sessionPageDataArr.push(sideItem)
                                    sessionPageDataArr.push(firstPageItem)
                                    if (secondPageItem) { sessionPageDataArr.push(secondPageItem) }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return {
        items: sessionPageDataArr,
        home_page: sessionHomePage,
        home_page_name: sessionHomePageName
    }
}

/**判斷報名狀態 */
export const SignUpState = (startTime: string, endTime: string) => {

    let obj: {
        label: string,
        color: 'default' | 'secondary' | 'primary'
    } = { color: "default", label: "" };

    if (startTime && endTime) {
        const now = new Date().getTime();
        const start = new Date(startTime.replace("T", " ")).getTime();
        const end = new Date(endTime.replace("T", " ")).getTime();

        if (now < start) {
            return obj = { color: "primary", label: "未開放" }
        } else if (now >= start && now <= end) {
            return obj = { color: "secondary", label: "進行中" }
        } else {
            return obj = { color: "default", label: "已過期" }
        }
    } else return obj = { color: "primary", label: "未設定報名時間" };

};

/** 隨機產生色碼
 * @description 色相(hue)為顏色主要屬性，表示色環上的位置，0度~360度; 0紅色、120綠色、240藍色; 
 * 固定偏移量137度，可以確保颜色均匀分布(chatgpt說的)
 */
export const RandomColor = (() => {
    let lastHue = 0 // 固定從紅色開始產生

    return () => {
        // 固定的色相偏移，確保差異大
        const hueOffset = 137 // gpt說137度是個接近黄金角度的偏移量，可以確保颜色均匀分布
        const hue = (lastHue + hueOffset) % 360 // 計算新的色相值
        const saturation = 40 // 固定稍低飽和度
        const lightness = 60 // 固定較明亮的亮度

        lastHue = hue // 更新紀錄的色相值
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`
    }
})()

/** 暫時先寫死Audi報表配色
 * @param ds_id 經銷商ID
 * @returns 
 */
export const AudiDealerColor = (ds_name: string) => {
    switch (ds_name) {
        case "Audi":
            return "#f2f2f2"
        case "Audi TPN":
            return "#000000"
        case "Audi TNS":
            return "#f50537"
        case "Audi TCH":
            return "#666666"
        case "Audi KSS":
            return "#b3b3b3"
        default:
            return RandomColor()
    }
}

/**
 * @description 遇到可預測錯誤時(回傳200但responseBody裏的success為false)自動throw error
 * @description 目前用於尚未支援autoThrowErrorFetch的Adapter API上
 */
export const autoThrowError = async <T>(requestObj: Promise<ResultObj<T>>): Promise<ResultObj<T>> => {
    const result = await requestObj;

    if (!result.success) {
        throw result
    }

    return result;
};

/**
 * @description 將dotNet6的時間格式轉換為預設時間格式
 * @description 僅用於dotNet6的adapter上
 * @param dateTime 2024-07-09T09:37:19.99(ISO 8601)
 * @returns 20240709093719990(yyyyMMddhhmmssSSS)
 */
export const dotNet6DateTimeToDefaulFormat = (dateTime: Date | string | null | undefined): string => {
    return dateTime ? new CustomDate(dateTime).toCustomFormat('yyyyMMddHHmmssSSS') : "";
}

/**
 * @description 將dotNet6的時間格式轉換為預設時間格式
 * @description 僅用於dotNet6的adapter上
 * @param dateTime 2024-07-09T09:37:19.99(ISO 8601)
 * @returns 20240709(yyyyMMdd)
 */
export const dotNet6DateToDefaulFormat = (dateTime: Date | string | null | undefined): string => {
    return dateTime ? new CustomDate(dateTime).toCustomFormat('yyyyMMdd') : "";
}

/**
 * @description 將預設日期時間格式轉換爲dotNet6的日期時間格式
 * @description 僅用於dotNet6的adapter上
 * @param dateTime 20240709093719990(yyyyMMddhhmmssSSS|yyyyMMddhhmmss|yyyyMMddhhmm|yyMMddhhmmssSSS|yyMMddhhmmss|yyMMddhhmm)
 * @returns 2024-07-09T09:37:19.99(ISO 8601)
 */
export const defaultDateTimeToDotNet6Format = (dateTime: Date | string | undefined | null): string | null => {
    return dateTime ? new CustomDate(dateTime).toCustomFormat("yyyy-MM-ddTHH:mm:ss.SSS") : null;
}

/**
 * @description 將預設日期格式轉換爲dotNet6的日期格式
 * @description 僅用於dotNet6的adapter上
 * @param dateTime 20240709093719990(yyyyMMddhhmmssSSS|yyyyMMddhhmmss|yyyyMMddhhmm|yyMMddhhmmssSSS|yyMMddhhmmss|yyMMddhhmm)
 * @returns 2024-07-09(ISO 8601)
 */
export const defaultDateToDotNet6Format = (dateTime: Date | string | undefined | null): string | null => {
    return dateTime ? new CustomDate(dateTime).toCustomFormat("yyyy-MM-dd") : null;
}

/**
 * @description 將查詢條件的起訖日期轉換爲dotNet6的日期時間格式，並補上當日的頭尾時間
 * @description 僅用於dotNet6的adapter上
 * @description 訖日若不補到當日最後一秒，會把當天整天排除在查詢範圍外
 * @param date 20240709(yyyyMMdd) 或 2024-07-09 或 ISO 8601
 * @param boundary start 取當日 00:00:00、end 取當日 23:59:59
 * @returns 2024-07-09T00:00:00.000 / 2024-07-09T23:59:59.000，無法解析時回傳原字串
 */
export const defaultRangeDateToDotNet6Format = (date: Date | string | undefined | null, boundary: "start" | "end"): string | null => {
    if (!date) return null;
    try {
        const boundaryDate = new CustomDate(date);
        if (boundary === "end") boundaryDate.setHours(23, 59, 59, 0);
        else boundaryDate.setHours(0, 0, 0, 0);
        return defaultDateTimeToDotNet6Format(boundaryDate);
    } catch {
        // 解析不了就原樣送出，交由後端判斷
        return typeof date === "string" ? date : null;
    }
}

/**
 * @description 將預設純時間格式轉換爲dotNet6的時間格式
 * @description 僅用於dotNet6的adapter上
 * @param time 093719990(hhmmssSSS|hhmmss|hhmm)
 * @returns 09:37:19.99(HH:mm:ss.SSS)
 */
export const defaultTimeToDotNet6Format = (time: string | undefined | null): string | null => {
    if (!time) return null;
    const t = time.trim();
    // 只接受純數字
    if (!/^\d+$/.test(t)) return null;

    const hh = t.substring(0, 2);
    const mm = t.substring(2, 4);
    // hhmmss(6碼) 或 hhmmssSSS(9碼)
    const ss = t.length >= 6 ? t.substring(4, 6) : '00';
    // SSS 毫秒，只取前兩位符合 dotNet6 的 .SS 格式（例如 990 → .99）
    const ms = t.length >= 9 ? t.substring(6, 8) : '';

    if (!hh || !mm) return null;

    return ms
        ? `${hh}:${mm}:${ss}.${ms}`
        : `${hh}:${mm}:${ss}`;
}

/**
 * @description handleInput產生器
 * @param setState 想要更新的state setter
 * @param beforeSet 在更新state之前觸發的callback函數
 * @example
 * // 產生專用的 handler
 * const searchHandleInput = createHandleInput(setBulletinListParams);
 *
 * //在input中使用
 * <ReactOutlineInput
 * ...
 * onChange={searchHandleInput}
 * />
 */
export function createHandleInput<T>(
    setState: React.Dispatch<React.SetStateAction<T>>,
    beforeSet?: (e: HandleEvent, value: string | number | boolean | null, prev: T, fieldName: string) => Partial<T> | void
) {
    return (e: HandleEvent) => {
        const fieldName = e.target.name.split("--")[1];
        const type = e.target.type;
        let value: string | number | boolean | null = e.target.value;

        if (type === "date") {
            if (value) {
                const selectedDate = new CustomDate(value as string).toYYYYMMDD();
                value = isNaN(Number(selectedDate)) ? "" : selectedDate;
            } else {
                value = "";
            }
        } else if (type === "time") {
            if (value) {
                const selectedDate = new CustomDate(value as string).toHHmm();
                value = isNaN(Number(selectedDate)) ? "" : selectedDate;
            } else {
                value = "";
            }
        } else if (type === "checkbox") {
            value = e.target.checked || false
        }

        setState((prev) => {
            const overrideState = beforeSet?.(e, value, prev, fieldName);
            return {
                ...prev,
                [fieldName]: value,
                ...(overrideState || {}),
            };
        });
    };
}

/**
 * @description debounceHandleInput產生器,會延遲觸發state setter更新
 * @param setState 想要更新的state setter
 * @param beforeSet 在更新state之前觸發的callback函數
 * @param delay 延遲時間，func內預設為700毫秒
 * @example
 * // 產生專用的 handler
 * const debouncedSearchHandleInput = createDebouncedInputHandler(setBulletinListParams);
 *
 * //在input中使用
 * <ReactOutlineInput
 * ...
 * onChange={debouncedSearchHandleInput}
 * />
 */
export function createDebouncedInputHandler<T>(
    setState: React.Dispatch<React.SetStateAction<T>>,
    beforeSet?: (value: string | number, prev: T, fieldName: string) => Partial<T> | void,
    delay?: number
) {
    const handler = (fieldName: string, value: string | number) => {
        setState((prev) => {
            const overrideState = beforeSet?.(value, prev, fieldName);
            return {
                ...prev,
                [fieldName]: value,
                ...(overrideState || {}),
            };
        });
    };

    // 每個 fieldName 維護獨立的 timeout，避免不同欄位的 debounce 互相取消
    const timeouts: Record<string, ReturnType<typeof setTimeout>> = {};

    // 回傳直接可綁 onChange 的函式
    return (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const fieldName = e.target.name.split("--")[1];
        const value = e.target.value;
        if (timeouts[fieldName]) clearTimeout(timeouts[fieldName]);
        timeouts[fieldName] = setTimeout(() => handler(fieldName, value), delay ?? 700);
    };
}

export function createHandleSelect<T>(
    setState: React.Dispatch<React.SetStateAction<T>>,
    beforeSet?: (e: HandleEvent, value: string | number | any[], prev: T, fieldName: string) => Partial<T> | void
) {
    return (e: HandleEvent) => {
        const fieldName = e.target.name.split("--")[1];
        const name = fieldName as keyof T;
        const key = e.target.key;

        setState((prev) => {
            //是多選
            if (Array.isArray(e.target.value) && key) {
                const value = (e.target.value !== null) ? e.target.value : [];
                const overrideState = beforeSet?.(e, value, prev, fieldName);
                return {
                    ...prev,
                    [name]: value.map(e => e[key]),
                    ...(overrideState || {})
                };

            } else {
                const value = (key && e.target.value !== null) ? e.target.value[key] : "";
                const overrideState = beforeSet?.(e, value, prev, fieldName);
                return {
                    ...prev,
                    [name]: value,
                    ...(overrideState || {}),
                };
            }
        });
    };
}

/**
 * @description 匯出Excel通用處理
 * @param apiFunction 你要打的搜尋API func,
 * @param params 需要要携帶的參數會自動幫你帶上excel: "Y",
 * @param handleError 錯誤處理func
 * @param setShowMainPageMask 選填，控制全頁loading遮罩的顯示/隱藏
 * @description 匯出期間會自動在畫面右下角顯示「檔案匯出中，請勿離開頁面」的持續通知(透過 GlobalSnackbar)，不需呼叫端額外處理
 * @example
 * const downloadModalClick = async (e: Event): Promise<void> => {
        e.stopPropagation();
        await handleExportExcel(carApiManager.CarSearch, pageSearch, responseMessage, setShowMainPageMask);
    }
 */
export const handleExportExcel = async (apiFunction: Function, params: any, handleError: (error: ResultObj) => void, setShowMainPageMask?: (show: boolean) => void) => {
    const downloadKey = globalEnqueueSnackbar(
        createElement(Box, { display: "flex", alignItems: "center", style: { gap: "8px" } },
            createElement(CircularProgress, { size: 20, style: { color: "#fff" } }),
            "檔案匯出中，請勿離開頁面..."
        ),
        { variant: "info", persist: true, preventDuplicate: true }
    );
    try {
        setShowMainPageMask?.(true);
        const res = await autoThrowError(apiFunction({
            ...params,
            excel: "Y",
            is_excel: true
        }))
        const apiVer = esd_storage.getItem('defaultApiVersion') || ""
        if (apiVer === "") handleError({ success: false, message: "無法取得API版本，請重新登入", data: null });

        const urlPath = (apiVer === ApiVersionName.FRAMEWORK ? res.data : res.message);
        if (!urlPath || (Array.isArray(urlPath) && urlPath.length === 0)) {
            globalEnqueueSnackbar("沒有資料可以匯出", { variant: "warning" });
            return;
        }
        const url = `${ExportURL}/${urlPath}`;
        window.open(url);
    } catch (error) {
        handleError(error as ResultObj);
    } finally {
        setShowMainPageMask?.(false);
        globalCloseSnackbar(downloadKey);
    }
}

/** 
 * 精確乘法 (解決 JS 浮點數精度問題)
 * @description 透過將小數轉為整數相乘後，再除以小數位數的倍數來還原
 */
export function preciseMultiply(arg1: number | string, arg2: number | string): number {
    let m = 0;
    const s1 = arg1.toString();
    const s2 = arg2.toString();

    try { if (s1.includes('.')) m += s1.split(".")[1].length; } catch (e) { }
    try { if (s2.includes('.')) m += s2.split(".")[1].length; } catch (e) { }

    const r1 = Number(s1.replace(".", ""));
    const r2 = Number(s2.replace(".", ""));

    return (r1 * r2) / Math.pow(10, m);
}

/** 
 * 精確除法 (解決 JS 浮點數精度問題)
 * @description 同樣將小數轉為整數相除，最後再乘上雙方小數位數長度的差值補償
 */
export function preciseDivide(arg1: number | string, arg2: number | string): number {
    let t1 = 0, t2 = 0;
    const s1 = arg1.toString();
    const s2 = arg2.toString();

    try { if (s1.includes('.')) t1 = s1.split(".")[1].length; } catch (e) { }
    try { if (s2.includes('.')) t2 = s2.split(".")[1].length; } catch (e) { }

    const r1 = Number(s1.replace(".", ""));
    const r2 = Number(s2.replace(".", ""));

    return (r1 * Math.pow(10, t2)) / (r2 * Math.pow(10, t1));
}

export function normalizeDsId(ds_id: string | number | null | undefined): string | undefined {
    //null, undefined, empty string, 0 都視為無效
    return ds_id ? ds_id.toString() : undefined;
}